import React from "react";
import "./PoliticaPrivacidad.css";

export default function EliminacionDatos() {
  return (
    <main className="privacy-page">
      <section className="privacy-hero">
        <a className="privacy-brand" href="/login" aria-label="Ir al inicio de MozzoApp">
          mozzo<span>app</span>
        </a>
        <p className="privacy-kicker">PRIVACIDAD</p>
        <h1>Eliminacion de datos</h1>
        <p className="privacy-lead">
          Puede solicitar la eliminacion de datos personales asociados a MozzoApp,
          incluidos los vinculados a una conversacion de WhatsApp.
        </p>
      </section>

      <article className="privacy-content">
        <section>
          <h2>Como realizar la solicitud</h2>
          <p>
            Envie un correo a
            <a href="mailto:privacidad@mozzoapp.com"> privacidad@mozzoapp.com</a>
            con el asunto &quot;Eliminacion de datos MozzoApp&quot;.
          </p>
          <p>
            Indique el nombre y correo de la cuenta, el numero de telefono utilizado
            en WhatsApp si corresponde, el restaurante relacionado y una descripcion
            de los datos que desea eliminar. No incluya contrasenas ni datos completos
            de tarjetas.
          </p>
          <p>
            Si la solicitud corresponde a una cuenta Rider, indique tambien que desea
            revisar o eliminar la documentacion de identidad y del vehiculo presentada.
          </p>
        </section>

        <section>
          <h2>Verificacion y tratamiento</h2>
          <p>
            Podemos solicitar informacion minima para verificar la identidad y evitar
            la eliminacion no autorizada de datos. Una vez validada la solicitud,
            eliminaremos o anonimizaremos la informacion alcanzada, salvo aquella que
            debamos conservar por obligaciones legales, fiscales, de seguridad o para
            resolver operaciones y reclamos pendientes.
          </p>
          <p>
            Cuando existan entregas, pagos, incidentes o revisiones pendientes, algunos
            registros pueden conservarse bloqueados durante el plazo necesario para
            atender esas obligaciones. La cuenta no podra seguir operando si se elimina
            la documentacion indispensable para validar al Rider.
          </p>
        </section>

        <section>
          <h2>Datos administrados por un restaurante</h2>
          <p>
            Si los datos pertenecen a un pedido tomado por un restaurante, tambien
            puede solicitar la eliminacion directamente a ese comercio. MozzoApp
            colaborara con el restaurante cuando la solicitud requiera acciones en la
            plataforma.
          </p>
        </section>

        <section>
          <h2>Mas informacion</h2>
          <p>
            Consulte la <a href="/politica-de-privacidad">Politica de privacidad</a>
            para conocer como MozzoApp recopila, utiliza y protege la informacion.
          </p>
        </section>
      </article>
    </main>
  );
}
